import { accessSteps } from '@/mocks/home';

export default function AccessSteps() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-medium tracking-[0.2em] text-primary-600">访问指引</span>
          <h2 className="mt-3 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
            打不开时，按这四步来
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            不用到处找教程。遇到黑料官网打不开或需要换地址，照着下面的顺序操作，基本都能顺利进入。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {accessSteps.map((step) => (
            <div
              key={step.no}
              className="group relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors duration-200 hover:border-primary-300 md:p-6"
            >
              <span className="font-heading text-3xl font-black text-primary-200 transition-colors duration-200 group-hover:text-primary-400">
                {step.no}
              </span>
              <span className="mt-4 flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className={`${step.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}